import { MapPinOff } from 'lucide-react';
import { Link } from 'react-router';
import { buttonVariants } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';

export function NotFoundPage() {
  return (
    <EmptyState
      icon={MapPinOff}
      titleAs="h1"
      title="Pagina non trovata"
      description="L'indirizzo richiesto non esiste."
      action={
        <Link to="/" className={buttonVariants()}>
          Torna al cruscotto
        </Link>
      }
    />
  );
}
